import {
  RemoveAllWorkflowMemberSharesDocument,
  RemoveAllWorkflowTeamSharesDocument,
  SetAllWorkflowMemberSharesDocument,
  SetAllWorkflowTeamSharesDocument,
  SetWorkflowVisibilityDocument,
  ShareWorkflowDocument,
  ShareWorkflowTeamDocument,
  WorkflowAccessSummaryDocument,
  type WorkflowAccessSummaryQuery,
} from "#app/lib/data";
import { useAppData } from "#app/lib/data";

import { useObjectSharing } from "./use-object-sharing";

// Workflow flavor of useObjectSharing — same dialog contract as
// useItemSharing, against the workflow_share table.

const MUTATIONS = {
  share: ShareWorkflowDocument,
  shareTeam: ShareWorkflowTeamDocument,
  removeAllMemberShares: RemoveAllWorkflowMemberSharesDocument,
  removeAllTeamShares: RemoveAllWorkflowTeamSharesDocument,
  setAllMemberShares: SetAllWorkflowMemberSharesDocument,
  setAllTeamShares: SetAllWorkflowTeamSharesDocument,
  setVisibility: SetWorkflowVisibilityDocument,
};

const selectSummary = (data: WorkflowAccessSummaryQuery | undefined) =>
  data?.workflowAccessSummary ?? null;

const mergePage = (
  prev: WorkflowAccessSummaryQuery,
  next: WorkflowAccessSummaryQuery,
  list: "members" | "teams",
): WorkflowAccessSummaryQuery => {
  const p = prev.workflowAccessSummary;
  const n = next.workflowAccessSummary;
  return {
    ...next,
    workflowAccessSummary: {
      ...n,
      members: list === "members" ? [...p.members, ...n.members] : p.members,
      teams: list === "teams" ? [...p.teams, ...n.teams] : p.teams,
    },
  };
};

export function useWorkflowSharing(
  workflowId: string | null,
  search?: string,
) {
  // app-provider funnels WorkspaceData through a local reducer (not a
  // live useQuery), so a plain Apollo refetch doesn't update the
  // sidebar's workflow list. Hit AppData.refetch() after visibility
  // flips to re-dispatch the payload and rerender consumers (sidebar's
  // lock chip).
  const { refetch: refetchAppData } = useAppData();

  return useObjectSharing({
    id: workflowId,
    search,
    idKey: "workflowId",
    summaryDocument: WorkflowAccessSummaryDocument,
    mutations: MUTATIONS,
    selectSummary,
    mergePage,
    onVisibilityChange: refetchAppData,
  });
}
